module.exports = __webpack_public_path__ + "static/img/cells.c46a3b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cells.png
// module id = mY1a
// module chunks = 1